import React, { useState, useContext } from "react";

//Style
import Avatar from "@material-ui/core/Avatar";

//Assets
import Profile from "../../assets/Profile.png";

//Component
import ReactAudioPlayer from "react-audio-player";

//Context
import { AgentActionContext } from "../../context/AgentContext";
import { ClientActionContext } from "../../context/ClientContext";
import { FeedbackActionContext } from "../../context/FeedbackContext";

function Feeds(props) {
  const { data } = props;

  console.log("Data --> ", data);
  return (
    <div className="feedback">
      <FeedHeader data={data} />
      <FeedBody data={data} />
      <FeedFooter data={data} />
      <AudioPlayer data={data} />
    </div>
  );
}

export default Feeds;

const FeedHeader = (props) => {
  const { data } = props;

  //State
  const [agent, setAgent] = useState({});

  //Context
  const { agentsDetails } = useContext(AgentActionContext);

  const replaceD = data.createdAt.replace("D", "");
  const createdAt = replaceD.replace("T", " ");

  agentsDetails(data.agentID, setAgent);

  return (
    <div style={{ display: "flex", alignItems: "center", width: 250 }}>
      <Avatar
        alt="Profile Picture"
        src={agent.avatar ? agent.avatar : Profile}
        style={{ width: 50, height: 50 }}
      />
      <div style={{ margin: "0px 10px" }}>
        <h2 className="agentName">{agent.name} </h2>
        <h3 className="time">{createdAt} </h3>
      </div>
    </div>
  );
};

const FeedBody = (props) => {
  const {
    society,
    block,
    status,
    phase,
    street,
    category,
    areaSize,
    areaType,
    plotNo,
    precinct,
    sector,
  } = props.data;
  return (
    <div className="feedbody">
      <BodyPara label="Society Name" data={society} />
      <BodyPara label="Category" data={category} />
      <BodyPara label="Status" data={status} />
      <BodyPara label="Plot Number" data={plotNo} />
      <BodyPara label="Area Type" data={areaType} />
      <BodyPara label="Area Size" data={areaSize} />
      <BodyPara label="Block" data={block} />
      <BodyPara label="Sector" data={sector} />
      <BodyPara label="Phase" data={phase} />
      <BodyPara label="Street" data={street} />
      <BodyPara label="Precinct" data={precinct} />
    </div>
  );
};

const BodyPara = (props) => {
  const { label, data } = props;
  return data ? (
    <p>
      <b>{label}: </b>
      {data}
    </p>
  ) : null;
};

const FeedFooter = (props) => {
  const { data } = props;

  //State
  const [client, setClient] = useState({});
  //Context
  const { clientDetail } = useContext(ClientActionContext);

  clientDetail(data.clientID, setClient);
  return (
    <div>
      <h3>Client: {client.name ? client.name : null}</h3>
      <h4>Phone Number: {client.phoneNo ? client.phoneNo : null} </h4>
      {data.demand ? <h4>Demand Price: {data.demand}</h4> : null}
      {data.final ? <h4>Final Price: {data.final}</h4> : null}
    </div>
  );
};

const AudioPlayer = (props) => {
  const { data } = props;

  //State
  const [audio, setAudio] = useState({});
  //Context
  const { getRec } = useContext(FeedbackActionContext);

  getRec(data.feedID, setAudio);
  return audio ? <ReactAudioPlayer src={audio} controls /> : null;
};
